"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var useStyles = core_1.makeStyles(function () { return ({
    root: {
        padding: '0',
        display: 'flex',
        alignItems: 'center'
        // width: 400
    },
    input: {
        marginLeft: 8,
        flex: 1
    },
    iconButton: {
    // padding: 10
    }
}); });
var CustomTextField = function (_a) {
    var InputProps = _a.InputProps, ref = _a.ref, other = __rest(_a, ["InputProps", "ref"]);
    var classes = useStyles({});
    // const { InputProps, classes, ref, ...other } = props
    // console.log(props)
    return (react_1.default.createElement(core_1.Paper, { className: clsx_1.default('faq-search', classes.root), elevation: 1 },
        react_1.default.createElement(core_1.InputBase, __assign({ className: classes.input }, InputProps, other)),
        react_1.default.createElement(core_1.IconButton, { className: clsx_1.default('faq-search-button', classes.iconButton), "aria-label": "Search", type: "submit" },
            react_1.default.createElement(Search_1.default, { className: "faq-search-icon", fontSize: "large", component: function (svgProps) { return (react_1.default.createElement("svg", __assign({}, svgProps),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("linearGradient", { id: "faq-search-gradient" },
                            react_1.default.createElement("stop", { offset: "0" }),
                            react_1.default.createElement("stop", { offset: "1" }))),
                    svgProps.children)); } }))));
};
function renderInput(inputProps) {
    return react_1.default.createElement(CustomTextField, { InputProps: inputProps.InputProps });
}
exports.renderInput = renderInput;
function renderSuggestion(_a) {
    var suggestion = _a.suggestion, index = _a.index, itemProps = _a.itemProps, highlightedIndex = _a.highlightedIndex, selectedItem = _a.selectedItem, query = _a.query, onClick = _a.onClick;
    var isHighlighted = highlightedIndex === index;
    var isSelected = (selectedItem || '').indexOf(suggestion.title) > -1;
    return (react_1.default.createElement(core_1.MenuItem, __assign({}, itemProps, { key: suggestion.id, selected: isHighlighted, component: "div", style: {
            fontWeight: isSelected ? 500 : 400
        }, onClick: function (e) {
            e.preventDefault();
            onClick("answer/" + suggestion.id + "?query=" + encodeURIComponent(query));
        } }), suggestion.title));
}
exports.renderSuggestion = renderSuggestion;
//# sourceMappingURL=renderer.js.map